var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.classes,style:(_vm.resize),attrs:{"src":_vm.src},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }